import { motion } from "framer-motion";
import data from "../../data/index.json";
import "./MySkills.css";

const placeholder =
  "data:image/svg+xml;charset=utf-8," +
  encodeURIComponent(
    `<svg xmlns='http://www.w3.org/2000/svg' width='120' height='120'><rect width='100%' height='100%' fill='#f3f4f6'/><text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle' font-family='Arial' font-size='12' fill='#c7c7c7'>No icon</text></svg>`
  );

export default function MySkills() {
  const containerVariants = {
    hidden: {},
    visible: {
      transition: { staggerChildren: 0.07 },
    },
  };

  const cardVariant = {
    hidden: { opacity: 0, y: 10 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.45, ease: "easeOut" } },
  };

  return (
    <section className="skills-section" id="mySkills" aria-labelledby="skills-heading">
      <div className="skills-header">
        <p className="section-title">My Skills</p>
        <h2 id="skills-heading" className="skills-heading">My Expertise</h2>
      </div>

      <motion.div
        className="skills-grid"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.15 }}
      >
        {Array.isArray(data?.skills) && data.skills.length ? (
          data.skills.map((item, i) => {
            const { src, title, description, level } = item;
            return (
              <motion.article
                className="skill-card"
                key={item.id ?? `${title ?? "skill"}-${i}`}
                variants={cardVariant}
                whileHover={{ y: -6, boxShadow: "0 18px 40px rgba(2,6,23,0.08)" }}
                tabIndex={0}
                aria-label={`${title} skill`}
              >
                <div className="skill-media" aria-hidden>
                  <img
                    src={src ?? placeholder}
                    alt={title ? `${title} logo` : "skill icon"}
                    loading="lazy"
                    decoding="async"
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = placeholder;
                    }}
                  />
                </div>

                <div className="skill-body">
                  <h3 className="skill-title">{title}</h3>
                  {description && (
                    <p className="skill-desc">{description}</p>
                  )}

                  {/* optional proficiency bar when "level" exists (0-100) */}
                  {typeof level === "number" && (
                    <div className="skill-level" aria-hidden>
                      <div className="skill-level-bar" style={{ width: `${Math.max(0, Math.min(100, level))}%` }} />
                      <span className="skill-level-label">{Math.round(level)}%</span>
                    </div>
                  )}
                </div>
              </motion.article>
            );
          })
        ) : (
          <div className="skills-empty">No skills found.</div>
        )}
      </motion.div>
    </section>
  );
}
